// TODO: Fix this auto-generated suppression.
// eslint-disable-next-line rulesdir/require-next-link-wrapper
import Link, { LinkProps } from 'next/link'
import { FC, PropsWithChildren } from 'react'

import { MediaAsContents } from '@syconium/little-miss-figgy'

type MediaSize = 'sm' | 'md' | 'lg'

type GreaterThanProps = {
  greaterThanOrEqual: MediaSize
  lessThan?: never
}

type LessThanProps = {
  greaterThanOrEqual?: never
  lessThan: MediaSize
}

type Props = PropsWithChildren<
  (GreaterThanProps | LessThanProps) & {
    onClick?(): void
  } & LinkProps
>

// This component is used to show a Link on one device, but a fragment on another.
export const LinkWhen: FC<Props> = ({
  children,
  greaterThanOrEqual,
  lessThan,
  onClick,
  ...rest
}) => {
  const linkCondition = greaterThanOrEqual ? { greaterThanOrEqual } : { lessThan }
  const oppositeCondition = greaterThanOrEqual
    ? { lessThan: greaterThanOrEqual }
    : { greaterThanOrEqual: lessThan }

  return (
    <>
      <MediaAsContents {...linkCondition}>
        <Link onClick={onClick} {...rest}>
          {children}
        </Link>
      </MediaAsContents>
      <MediaAsContents {...oppositeCondition}>{children}</MediaAsContents>
    </>
  )
}
